module.exports = __webpack_public_path__ + "static/media/reach_logo.db91f1d8.png";